import { z } from 'zod';
import { ErrorCode } from './error-codes';
export const PASSWORD_RULES = {
    minLength: 8,
    patterns: {
        lowercase: /[a-z]/,
        uppercase: /[A-Z]/,
        numeric: /[0-9]/
    }
};
// Product policy: passwords are capped at 72 UTF-8 bytes. The limit predates
// the Zitadel migration (bcrypt-hashed imports truncate beyond it) and is kept
// as a compatibility ceiling for imported credentials. Cap on UTF-8 byte
// length — not JS string length, which counts UTF-16 code units and
// undercounts multibyte characters.
export const PASSWORD_MAX_BYTES = 72;
const utf8Encoder = new TextEncoder();
export const PasswordSchema = z.string().min(PASSWORD_RULES.minLength, ErrorCode.FIELD_TOO_SHORT).regex(PASSWORD_RULES.patterns.lowercase, ErrorCode.FIELD_INVALID_PASSWORD).regex(PASSWORD_RULES.patterns.uppercase, ErrorCode.FIELD_INVALID_PASSWORD).regex(PASSWORD_RULES.patterns.numeric, ErrorCode.FIELD_INVALID_PASSWORD).refine((value)=>utf8Encoder.encode(value).length <= PASSWORD_MAX_BYTES, ErrorCode.FIELD_TOO_LONG);

//# sourceMappingURL=password-validation.js.map